import { EventEmitter, InjectionToken } from '@angular/core';

export const INotifierToken = new InjectionToken<string>("INotifierToken");

export interface INotifier {

    notify(message: string, options?: any);

    setOkButtonVisibility(visibility : boolean);

    setDismissVisibility(visibility : boolean);

    OnNotify: EventEmitter<string>;

    onOkButtonVisibilityChnage: EventEmitter<boolean>;

    onDismissButtonVisibilityChnage: EventEmitter<boolean>;
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/contracts/INotifier.ts